module.exports = __webpack_public_path__ + "assets/img/8.d0a6df2a.png";